
import React from 'react';
import { Typography } from '@mui/material';
import classnames from 'classnames';
import { withStyles } from 'tss-react/mui';

const styles = {
  AccessMapArtisan: {
    color: 'dodgerblue',
    textDecoration: 'underline',
  },
  center: {
    textAlign: 'center',
    marginBottom: 15,
  },
};

const ArtisanInfo = ({ data, classes }) => {
  const addressArtisan = data ?
    data.get('billingAddress') : {};

  return ( data && <div>
    <Typography variant="h5" className={classes.center}>
      {`${data.get('name')} ${data.get('firstname')} - ${data.get(
        'companyName'
      )}`}
    </Typography>
    <Typography
      variant="body1"
      className={classnames(classes.center, classes.AccessMapArtisan)}
    >
      {`${addressArtisan.get('number')} ${addressArtisan.get('road')}
              , ${addressArtisan.get('zipcode')} ${addressArtisan.get('city')}`}
    </Typography>
  </div>
  ); };


export default withStyles(ArtisanInfo, styles);